import React from 'react';
import styles from './Copyable.module.css';
import { ReactComponent as CopyIcon } from '../../../../../../assets/Copy.svg';
import cn from 'classnames';
import copyToClipboard from 'copy-to-clipboard';
import { showNotification } from '../../../../../../utils/showNotification';

type CopyableProps = {
    children: string;
    className?: string;
};

const Copyable = ({ children, className }: CopyableProps) => {
    const handleCopyToClipboard = () => {
        if (!children) {
            return;
        }

        copyToClipboard(children);
        showNotification('Copied!', 'info');
    };

    return (
        <button className={cn(styles.copyButton, className)} onClick={handleCopyToClipboard}>
            <span className={styles.content}>{children}</span>
            <CopyIcon className={styles.copyIcon} />
        </button>
    );
};

export default Copyable;
